import { render } from "./MessageStatus.vue?vue&type=template&id=8845583a&scoped=true"
import script from "./MessageStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageStatus.vue?vue&type=script&setup=true&lang=js"

import "./MessageStatus.vue?vue&type=style&index=0&id=8845583a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8845583a"],['__file',"resources/js/components/whatsapp-managment/includes/components/MessageStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8845583a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8845583a', __exports__)) {
    console.log('reload')
    api.reload('8845583a', __exports__)
  }
  
  module.hot.accept("./MessageStatus.vue?vue&type=template&id=8845583a&scoped=true", () => {
    console.log('re-render')
    api.rerender('8845583a', render)
  })

}


export default __exports__